import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { WalletProvider } from './context/WalletContext';
import Layout from './components/Layout';
import PublicSite from './pages/PublicSite';
import PlansPage from './pages/PlansPage';
import StakingPage from './pages/StakingPage';
import DashboardPage from './pages/DashboardPage';
import WalletPage from './pages/WalletPage';
import InvitePage from './pages/InvitePage';
import SupportPage from './pages/SupportPage';
import IncomePage from './pages/IncomePage';
import TeamPage from './pages/TeamPage';
import RankPage from './pages/RankPage';
import CommissionPage from './pages/CommissionPage';
import LevelPage from './pages/LevelPage';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <WalletProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/dashboard/:refWallet" element={<DashboardPage />} />
                <Route path="/plans" element={<PlansPage />} />
                <Route path="/staking" element={<StakingPage />} />
                <Route path="/wallet" element={<WalletPage />} />
                <Route path="/income" element={<IncomePage />} />
                <Route path="/commission" element={<CommissionPage />} />
                <Route path="/level" element={<LevelPage />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/rank" element={<RankPage />} />
                <Route path="/invite" element={<InvitePage />} />
                <Route path="/support" element={<SupportPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </WalletProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
